export const submitErrorTranslations = {
  en: {
    invalidFileType: 'One of your files is not an accepted file format.',
    fileTooLarge: 'One of your files is over the size limit.',
    invalidFieldsConfig: 'This form has changed. Please reload the page and try again.',
  },
  is: {
    invalidFileType: 'Ein af skránum þínum er ekki á leyfilegu skráarsniði.',
    fileTooLarge: 'Ein af skránum þínum er yfir stærðarmörkum.',
    invalidFieldsConfig:
      'Þetta form hefur breyst. Vinsamlegast endurhladdu síðuna og prófaðu aftur.',
  },
  dk: {
    invalidFileType: 'En af dine filer er ikke et tilladt filformat.',
    fileTooLarge: 'En af dine filer overskrider størrelsesgrænsen.',
    invalidFieldsConfig: 'Denne formular er ændret. Genindlæs venligst siden og prøv igen.',
  },
};
